import { useEffect, useState } from "react"

import { Flex, Modal, Typography } from "antd"
import classNames from "classname"
import { useDispatch, useSelector } from "react-redux"

import Icon from "../../../../../Icon"
import { useEnrollmentModal } from "./hooks/useEnrollmentModal"

import styles from "./EnrollmentModal.module.less"

const { Text } = Typography

const EnrollmentInfoModal = () => {
  const dispatch = useDispatch()
  const { isAdmin } = useSelector((state) => state.auth)
  const { enrollmentData } = useSelector((state) => state.health)
  const { isMobile } = useSelector((state) => state.nav)
  const [open, setOpen] = useState(false)

  const { open: openEnrollmentModal } = useEnrollmentModal()

  useEffect(() => {
    if (enrollmentData?.show_pop_up && !isAdmin) {
      setOpen(true)
    }
  }, [enrollmentData?.show_pop_up, isAdmin])

  const handleEnroll = () => {
    setOpen(false)
    openEnrollmentModal()
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      onCancel={() => setOpen(false)}
      getContainer={document.querySelector(".main-layout")}
      centered={!isMobile}
      closeIcon={<Icon type="cross_small" />}
      className={classNames(styles.modal, styles.infoModal)}
      classNames={{ content: "clear-bg" }}
      width="100%"
      okText="Enroll in VAMP now"
      cancelText="Maybe later"
      onOk={handleEnroll}
      okButtonProps={{
        size: "large"
      }}
      cancelButtonProps={{
        size: "large"
      }}
    >
      <Flex vertical gap={8}>
        <Text className={styles.title}>Visa Acquirer Monitoring Program (VAMP)</Text>
        <Flex vertical gap={20}>
          <Flex vertical>
            <Text strong>What is VAMP?</Text>
            <Text>
              VAMP is Visa’s program that monitors your business for fraud and disputes
              (chargebacks).
            </Text>
          </Flex>
          <Flex vertical>
            <Text strong>How to enroll?</Text>
            <Text>
              Simply click the “Enroll” button in the top right corner and confirm your
              participation.
            </Text>
          </Flex>
          <Flex vertical>
            <Text strong>Important:</Text>
            <Text>
              After enrolling, data will not appear immediately. It usually takes 3 to 7 days for
              the first data to show up in the dashboard.
            </Text>
          </Flex>
          <Text>Would you like to enroll in VAMP now?</Text>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default EnrollmentInfoModal
